export type BannerProps = {
  title: string;
  iconClassName: string;
  variant?: "warning" | "danger";
  textDark?: boolean;
  className?: string;
  onDismiss?: () => void;
  children?: React.ReactNode;
  "data-test-id"?: string;
};

export const Banner: React.FC<BannerProps> = ({
  title,
  iconClassName,
  variant = "warning",
  textDark = false,
  className = "p-5 mb-0 mt-10",
  onDismiss,
  children,
  "data-test-id": testId,
}) => {
  const textClassName = textDark ? " text-dark" : "";

  return (
    <div
      className={`alert alert-dismissible bg-${variant} d-flex flex-column flex-sm-row align-items-center ${className}`}
    >
      <div className="d-flex flex-row align-items-center">
        <span className={`fa ${iconClassName} fa-xl me-4${textClassName}`}></span>
        <div className={`d-flex flex-column pe-0 pe-sm-10${textClassName}`}>
          <h5 className={`mb-1${textClassName}`}>{title}</h5>
          <span>{children}</span>
        </div>
      </div>

      <button
        data-test-id={testId}
        type="button"
        className="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto h-20px w-20px"
        data-bs-dismiss="alert"
        onClick={onDismiss}
      >
        <span className={`fa fa-times${textClassName}`}></span>
      </button>
    </div>
  );
};
